define('common/views/trial_expiration_popup',['require','exports','module','common/views/modal_view','common/models/appstate','services/auth','env','jquery','i18n','ldsh!../templates/trial_expiration_popup'],function (require, exports, module) {
  'use strict';

  var ModalView = require('common/views/modal_view'),
    AppState = require('common/models/appstate'),
    Auth = require('services/auth'),
    authInfo = Auth.getAuthInfo(),
    config = require('env');
  var $ = require('jquery');
  var i18n = require('i18n');

  module.exports = ModalView.extend(
    {
      template: require('ldsh!../templates/trial_expiration_popup'),
      events: {
        'click .js-accept': 'accept',
      },
      helpers: function () {
        return {
          paymentsUrl: config.paymentsUrl,
          companyId: authInfo.getCompanyId(),
        };
      },
      accept: function (e) {
        e.preventDefault();
        e.stopPropagation();
        AppState.markAsDisplayed();
        this.hide();
      },
      onRender: function () {
        this.$el.i18n();
      },
    },
    {
      show: function () {
        var popup = new module.exports();
        return popup;
      },
    }
  );
});

